import { h } from 'preact'
import ButtonControl from '../button-control/index'
import Overview from '../overview'
import globals from '../../utils/globals'
import EmptyPage from '../empty-page/EmptyPage'
import UserCell from '../overview/cells/UserCell'
import StatusCell from '../overview/cells/StatusCell'

const EmailCampaignOverview = () => {
  function getColumns () {
    return [
      { header: 'Email title',
        accessor: 'title',
        cell:
            ({ title, url, status } : { title: string, url: string, status: string }) =>
              status !== 'Sent' ? <a href={window.location.origin + url} className='qa-title-link'>{title}</a> : title,
        size: 'xl',
        isFixed: true },
      { header: 'Creator', accessor: 'sender', cell: UserCell('sender') },
      { header: 'Status', accessor: 'status', cell: StatusCell(), size: 'xs' }
    ]
  }

  return (
    <div className='email-campaigns'>
      <Overview
        type='email-campaign'
        headerTitle='Email Campaigns'
        headerButtons={[
          <a href='/email/email-template/1'>
            <ButtonControl
              title='Customise email template'
              newStyle
              size='medium'
              class='qa-customise-email-template'
            />
          </a>,
          <a href='/email/new/email-campaign'>
            <ButtonControl
              title='Add email campaign'
              variant='brand'
              newStyle
              size='medium'
              class='qa-add-email-campaign'
            />
          </a>]}
        rowId='id'
        endpoint={'/emailCampaign/list'}
        dataKey='emailCampaigns'
        model={getColumns()}
        EmptyStateComponent={<EmptyPage
          img_src={`${globals('defaultCdn')}/images/empty_page.png`}
          header='There are no email campaigns yet'
          text={'Seems like no one on your team has created an email campaign. \n Start now by creating one.'}
          button={{ link: '/email/new/email-campaign', text: 'Add email campaign' }}
        />}
        withPagination={{
          page: 1,
          pageSize: 25
        }}
        isBeta={true}
      />
    </div>
  )
}

export default EmailCampaignOverview
